import { formatJMD } from '../../lib/finances';
import { buildIncomeStatement, formatPercent } from '../../lib/financeReports';

function SectionRows({ title, rows, total, totalLabel }) {
  return (
    <>
      <tr className="pnl-section-head">
        <td>{title}</td>
        <td />
      </tr>
      {rows.length === 0 ? (
        <tr>
          <td className="pnl-indent pnl-none">Nothing recorded</td>
          <td className="entry-table-numeric">{formatJMD(0)}</td>
        </tr>
      ) : (
        rows.map((row) => (
          <tr key={row.label}>
            <td className="pnl-indent">{row.label}</td>
            <td className="entry-table-numeric">{formatJMD(row.amount)}</td>
          </tr>
        ))
      )}
      <tr className="pnl-subtotal">
        <td>{totalLabel}</td>
        <td className="entry-table-numeric">{formatJMD(total)}</td>
      </tr>
    </>
  );
}

export default function IncomeStatement({ income, expenses, period, periodLabel }) {
  const s = buildIncomeStatement(income, expenses, period);

  return (
    <div className="pnl">
      <div className="pnl-statement-head">
        <h3>Profit &amp; Loss</h3>
        <p>Skin Fairy JA Co. Ltd. — {periodLabel}</p>
      </div>

      <table className="entry-table pnl-table">
        <tbody>
          <SectionRows
            title="Revenue"
            rows={s.revenue}
            total={s.revenueTotal}
            totalLabel="Total revenue"
          />
          <SectionRows
            title="Cost of goods sold"
            rows={s.cogs}
            total={s.cogsTotal}
            totalLabel="Total cost of goods sold"
          />

          <tr className="pnl-highlight">
            <td>Gross profit</td>
            <td className="entry-table-numeric">{formatJMD(s.grossProfit)}</td>
          </tr>

          <SectionRows
            title="Operating expenses"
            rows={s.opex}
            total={s.opexTotal}
            totalLabel="Total operating expenses"
          />

          <tr className={'pnl-net' + (s.netProfit < 0 ? ' pnl-net-loss' : '')}>
            <td>{s.netProfit < 0 ? 'Net loss' : 'Net profit'}</td>
            <td className="entry-table-numeric">{formatJMD(s.netProfit)}</td>
          </tr>
        </tbody>
      </table>

      <div className="pnl-margins">
        <div className="pnl-margin">
          <span className="pnl-margin-label">Gross margin</span>
          <span className="pnl-margin-value">{formatPercent(s.grossMargin)}</span>
        </div>
        <div className="pnl-margin">
          <span className="pnl-margin-label">Net margin</span>
          <span className="pnl-margin-value">{formatPercent(s.netMargin)}</span>
        </div>
      </div>

      <p className="pnl-note">
        Cost of goods sold covers raw materials, packaging, and shipping &amp; fulfilment; every other
        expense category is treated as an operating expense.
      </p>
    </div>
  );
}
